export default __webpack_public_path__ + "static/media/alphabet-yellow-s.dc3cce15.png";